// Lightweight Panoramax build (<pnx-photo-viewer> and widgets, no map): used by the ERP page.
import './fontawesomeConfig'
import '@panoramax/web-viewer/build/cjs/index_photoviewer.js'
import './panoramaxSetup'
